import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../services/api";
import { useCallback } from "react";

function EditProduct() {

    const { id } = useParams();
    const navigate = useNavigate();

    const [name, setName] = useState("");
    const [price, setPrice] = useState("");
    const [description, setDescription] = useState("");
    const [stock, setStock] = useState("");
    const [imageFile, setImageFile] = useState(null);
    const [ highlight, setHighLight ] = useState("")

    const [categoryId, setCategoryId] = useState("");
    const [brandId, setBrandId] = useState("");

    const [categories, setCategories] = useState([]);
    const [brands, setBrands] = useState([]);
    const [features, setFeatures] = useState([])
    const [featureValues, setFeatureValues] = useState({})
    const [imagePreview, setImagePreview] = useState("")




    const fetchProduct = useCallback(async () => {
        try {
            const res = await API.get(`/api/products/${id}`);
            const p = res.data;

            setName(p.name);
            setPrice(p.price);
            setHighLight(p.highlight)
            setDescription(p.description);
            setStock(p.stock);
            setImagePreview(p.imageUrl)


            const categoryId = p.categories?.id;
            const brandId = p.brand?.id;

            setCategoryId(categoryId);

            await fetchBrands(categoryId);

            setBrandId(brandId);

            await fetchFeatures(categoryId);

            const featureRes = await API.get(`/api/productFeatureValue/${id}`)
            const map = {};
            featureRes.data.forEach(f => {
                map[f.featureId] = f.value
            })
            setFeatureValues(map)

        } catch (error) {
            console.log(error);
        }
    }, [id]);


    useEffect(() => {
        if (categories.length > 0 && id) {
            fetchProduct();
        }
    }, [categories, id, fetchProduct])

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const res = await API.get("/api/categories");
            setCategories(res.data || []);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchBrands = async (categoryId) => {
        try {
            const res = await API.get(`/api/admin/brand/${categoryId}`);
            setBrands(res.data || []);
        } catch (error) {
            console.log(error);
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();

        if (!categoryId || !brandId) {
            alert("Select category & brand");
            return;
        }

        const formData = new FormData();

        const featureArray = Object.keys(featureValues).map(id => ({
            featureId: Number(id),
            value: featureValues[id]
        }))

        formData.append("name", name);
        formData.append("price", price);
        formData.append("highlight", highlight)
        formData.append("description", description);
        formData.append("stock", stock);
        formData.append("categoryId", Number(categoryId));
        formData.append("brandId", Number(brandId));
        formData.append("features", JSON.stringify(featureArray))

        if (imageFile) {
            formData.append("image", imageFile);
        }

        try {
            await API.put(`/api/admin/products/updateProduct/${id}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            alert("Updated Successfully");
            navigate("/admin/products");

        } catch (error) {
            console.log(error);
        }
    };

    const fetchFeatures = async (id) => {
        try {
            const res = await API.get(`/api/admin/features/${id}`)
            setFeatures(res.data || [])
        } catch (error) {
            console.log(error)
        }
    }

    const handleFeatureChange = async (featureId, value) => {
        try {
            setFeatureValues(prev => ({
                ...prev,
                [featureId]: value
            }))
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        return () => {
            if (imagePreview && imagePreview.startsWith("blob:")) {
                URL.revokeObjectURL(imagePreview)
            }
        }
    }, [imagePreview])

    return (
        <div className="container-fluid py-4">
            <h2 className="mb-3 text-center text-md-start">
                Edit Product
            </h2>
            <div className="row g-4">

                {/* LEFT SECTION */}
                <div className="col-lg-6">
                    <div className="card shadow-sm p-4 h-100">

                        <h4 className="mb-3">Basic Details</h4>

                        <input
                            className="form-control mb-3"
                            placeholder="Product Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />

                        <input
                            className="form-control mb-3"
                            placeholder="Price"
                            value={price}
                            type="number"
                            name="price"
                            onChange={(e) => setPrice(e.target.value)}
                        />

                        <input
                            type="file"
                            className="form-control mb-3"
                            onChange={(e) => {
                                const file = e.target.files[0]
                                setImageFile(file)

                                if (file) {
                                    setImagePreview(URL.createObjectURL(file))
                                }
                            }
                            }
                        />

                        <p className="text-muted small">Current Image</p>
                        {imagePreview && (
                            <div className="mb-3 text-center">
                                <img
                                    src={imagePreview}
                                    alt="preview"
                                    style={{ width: "150px", height: "150px", objectFit: "contain" }}
                                />
                            </div>
                        )}

                        <select
                            className="form-control mb-3"
                            value={categoryId}
                            onChange={(e) => {


                                //Save category to backend
                                const id = e.target.value;
                                setCategoryId(id);

                                //Reset old values to replace with new one 
                                setBrandId("");
                                setFeatureValues({});

                                //Show Brands based on category
                                fetchBrands(id);

                                //Show features based on brands
                                fetchFeatures(id);
                            }}
                        >
                            <option value="">Select Category</option>
                            {categories.map(c => (
                                <option key={c.id} value={c.id}>{c.name}</option>
                            ))}
                        </select>

                        <select
                            className="form-control mb-3"
                            value={brandId}
                            onChange={(e) => setBrandId(e.target.value)}
                            disabled={!categoryId}
                        >
                            <option value="">Select Brand</option>
                            {brands.map(b => (
                                <option key={b.id} value={b.id}>{b.name}</option>
                            ))}
                        </select>

                        <textarea
                            className="form-control mb-3"
                            rows="3"
                            placeholder="HighLight"
                            value={highlight}
                            onChange={(e) => setHighLight(e.target.value)}
                        />

                        <textarea
                            className="form-control mb-3"
                            rows="5"
                            placeholder="Description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />

                        <input
                            className="form-control mb-3"
                            value={stock}
                            placeholder="Stock"
                            onChange={(e) => setStock(e.target.value)}
                        />

                    </div>
                </div>

                {/* RIGHT SECTION */}
                <div className="col-lg-6">
                    <div className="card shadow-sm p-4 h-100">

                        <h4 className="mb-3">Product Features</h4>

                        {!categoryId ? (
                            <p className="text-muted">Select category to load features</p>
                        ) : (
                            <div className="row">
                                {features.map(f => (
                                    <div className="col-md-6 mb-3" key={f.id}>
                                        <label className="form-label small fw-semibold">
                                            {f.name}
                                        </label>
                                        <input
                                            className="form-control"
                                            placeholder={`Enter ${f.name}`}
                                            value={featureValues[f.id] || ""}
                                            onChange={(e) =>
                                                handleFeatureChange(f.id, e.target.value)
                                            }
                                        />
                                    </div>
                                ))}
                            </div>
                        )}

                    </div>
                </div>

            </div>

            {/* BUTTON */}
            <div className="row mt-4">
                <div className="col-lg-12">
                    <button
                        onClick={handleUpdate}
                        className="btn btn-dark w-100 py-3"
                    >
                        Update Product
                    </button>
                </div>
            </div>

        </div>
    )
}

export default EditProduct;